import * as React from "react";
import { AgencyId } from "../messages/ObjectIds";
import { STRINGS } from "../strings";
import { Agency } from "../system/AppState/AppAgenciesState";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { translate } from "../translate";
import { HashMap } from "../utils/HashMap";
import ContactSupportList from "./ContactSupportList";
import GenericSettingsScreen from "./GenericSettingsScreen";

interface SettingsHelpScreenProps {
  caregiver: AppCaregiver;
  agencies: HashMap<AgencyId, Agency>;
  getAnomalies: (noEncode: boolean) => Promise<string>;
  onClickChatSupport: () => void;
  onClickGoBack: () => void;
}

const SettingsHelpScreen = (props: SettingsHelpScreenProps) => {
  return (
    <GenericSettingsScreen title={translate(STRINGS.HELP)} onClickGoBack={props.onClickGoBack}>
      <ContactSupportList
        agencies={props.agencies}
        caregiver={props.caregiver}
        getAnomalies={props.getAnomalies}
        onClickChatSupport={props.onClickChatSupport}
      />
    </GenericSettingsScreen>
  );
};

export default React.memo(SettingsHelpScreen);
